export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: '9916cd3', dateTime: 1789076435552 };